<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="7" :sm="8">
            <a-form-item label="Phone" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-input placeholder="Please enter phone number" v-model="queryParam.mobileNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="ID Card" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-input placeholder="Please enter ID card" v-model="queryParam.curp"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="email" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-input placeholder="Please enter email" v-model="queryParam.email"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Product'">
              <a-select
                v-model="queryParam.appssid"
              >
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Complaint Type'">
              <dict-select
                v-model="queryParam.complainType"
                :dict-code="DICT_CODE.complainType"
                :begin="[{ value: '', label: 'All', labelEn: 'All' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Issue Type'">
                <dict-select
                  v-model="queryParam.questionType"
                  :dict-code="DICT_CODE.questionType"
                  :begin="[{ value: '', label: 'All', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Status'">
              <a-select
                v-model="queryParam.replyStatus"
              >
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="0">
                  Unprocessed
                </a-select-option>
                <a-select-option value="1">
                  Processed
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="10" :sm="8">
              <a-form-item label="Complaint Time">
                <a-range-picker
                  v-model="queryParam.createdTime"
                  format="YYYY-MM-DD" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">Reset</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        bordered
        @change="handleTableChange">
        <Dict slot="complainType" slot-scope="text" :dict-code="DICT_CODE.complainType" :value="text"/>
        <Dict slot="questionType" slot-scope="text" :dict-code="DICT_CODE.questionType" :value="text"/>
        <span slot="action" slot-scope="text, record">
          <a @click="editDictItem(record)"><a-icon type="setting"/>View</a>
        </span>
      </a-table>

    </div>
    <cust-leaving-detail ref="custLeavingDetail" @submit='searchQuery'></cust-leaving-detail>
  </a-card>
</template>

<script>
import moment from 'moment'
import { filterObj } from '@/utils/util'
import { deleteDict, clearDictCache, getRedisDictCache} from '@/webpublicapi/system'
import CustLeavingDetail from './CustleavingDetail'
import { getApplist} from '@/webpublicapi/order'
import {getCustLeavingMessage} from "@/webpublicapi/customer";
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';

export default {
  name: 'CustLeavingModal',
  components: {
    Dict,
    DictSelect,
    CustLeavingDetail
  },
  data () {
    return {
      moment,
      visible: false,
      toggleSearchStatus: false,
      // Pagination paramsdict
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dataSource: [],
      questionTypeList:[],
      complainTypeList:[],
      appList:[],
      // Query conditions
      queryParam: {
        "curp" : '',
        "mobileNo" : '',
        "email" : '',
        "createdTime" : undefined,
        "appssid" : '',
        "complainType" : '',
        "questionType" : '',
        "replyStatus" : '',
      },
      loading: false,
      // Table header
      columns: [
        {
          title: 'User Phone',
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: 'User Name',
          align: 'left',
          dataIndex: 'custName'
        },
        {
          title: 'Email',
          align: 'left',
          dataIndex: 'email'
        },
        {
          title: 'ID Card',
          align: 'left',
          dataIndex: 'curp'
        },
        {
          title: 'Complaint Type',
          align: 'left',
          dataIndex: 'complainType',
          scopedSlots: { customRender: 'complainType' }
        },
        {
          title: 'Issue Type',
          align: 'left',
          dataIndex: 'questionType',
          scopedSlots: { customRender: 'questionType' }
        },
        {
          title: 'Question Time',
          align: 'left',
          dataIndex: 'createTime'
        },
        {
          title: 'Processing Time',
          align: 'left',
          dataIndex: 'replyTime'
        },
        {
          title: 'Status',
          align: 'left',
          dataIndex: 'replyStatus',
          customRender: (text, record) => {
            if (text === 0) {
              return 'Unprocessed'
            } else if (text === 1) {
              return 'Processed'
            }
          }
        },
        {
          title: 'Operator',
          align: 'left',
          dataIndex: 'optUser'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created () {
    getApplist().then(res => {
      this.appList = res.data || [];
    })
    this.loadData(1)
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getCustLeavingMessage(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams () {

      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        beginDate: createdTime && this.transformTime(createdTime[0]),
        endDate: createdTime && this.transformTime(createdTime[1]),
      }
      delete data.createdTime;
      var param = Object.assign({}, data)

      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    handleTableChange (pagination, filters, sorter) {
      // TODO Filter
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      }
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd () {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = 'Add'
    },
    handleEdit (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = 'Edit'
    },
    handleDelete(id){
      deleteDict({id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    clearCache(id){
      clearDictCache({id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    getRedisCache(id){
      getRedisDictCache({id}).then((res) => {
        const h = this.$createElement;
        if (res.code === 1000) {
          this.$info({
            title: 'Redis Values',
            content: h('div', {}, [
              h('p', res.data.list == undefined?'redis in listYesEmpty ':'list====>'+res.data.list),
              h('p', res.data.map ==  undefined?'redis in mapYesEmpty ':'map====>'+res.data.map),
            ]),
            onOk() {},
          });
          console.log(res.data)
        }
      })
    },
    // Deselect
    cancelDict () {
      //this.dict = ''
      this.visible = false
      this.loadData()
    },
    // Edit dictionary data
    editDictItem (record) {
      this.$refs.custLeavingDetail.show(record)
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.curp = ''
      that.queryParam.mobileNo = ''
      that.queryParam.email = ''
      that.queryParam.createdTime = undefined;
      that.queryParam.appssid = ''
      that.queryParam.complainType = ''
      that.queryParam.questionType = ''
      that.queryParam.replyStatus = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk () {
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>
